import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    link: {
        color: 'black',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    zipAutocomplete: {
        '& .MuiAutocomplete-endAdornment': {
            display: 'none',
        },
    },
    divider: {
        marginBottom: '5px !important',
    },
    reactionBox: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #9F9F9F',
        textAlign: 'justify',
    },
    personCard: {
        width: '100%',
        '& .MuiCardHeader-root': {
            padding: 10,
            backgroundColor: '#eee',
        },
        '& .MuiCardHeader-title': {
            fontSize: 16,
            fontWeight: 'bold',
        },
        '& .MuiCardHeader-action': {
            marginTop: -10,
            marginRight: -5,
            '& .MuiButton-root': {
                minWidth: 'auto',
            },
        },
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important'
        }
    },
}))

export default useStyles
